
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import { Control, RepeaterOptions } from "@/types/controls";
import { ElementStudioContext } from "./ElementStudioTabsAndPanels.vue";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";

const DEFAULT_REPEATER_VALUE = {
  titleTemplate: "",
  defaultTitle: "",
  buttonName: ""
};

@Component({
  components: { DropdownInput, TextInput }
})
export default class ElementStudioRepeaterOptions extends Vue {
  @Prop()
  value!: RepeaterOptions;
  @Inject("context") readonly context!: ElementStudioContext;

  @Prop()
  control!: Control;

  get internalValue() {
    return this.value || DEFAULT_REPEATER_VALUE;
  }

  get controlSlugs() {
    return this.control.children.map(c => c.slug);
  }

  get mediaControlSlugs() {
    return this.control.children
      .filter(c => c.options.type === "wpmedia")
      .map(c => c.slug);
  }

  appendVariableToTitle(variable: string) {
    const title = this.internalValue.titleTemplate;
    const duplicated = title.includes(`{${variable}}`);

    if (duplicated) return;

    const newTitleTemplate = `${title} {${variable}}`.trim();
    this.update(newTitleTemplate, "titleTemplate");
  }

  update(text: string | null, field: string) {
    this.emit({
      ...this.internalValue,
      [field]: text ?? ""
    });
  }

  updateGalleryMode(galleryMode: boolean) {
    this.emit({
      ...this.internalValue,
      galleryMode
    });
  }

  emit(repeaterOptions: RepeaterOptions) {
    this.$emit("input", repeaterOptions);
  }
}
